var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, makeStyles, Tooltip, Typography, } from '@material-ui/core';
import { AttachFile, ExpandMore } from '@material-ui/icons';
import { API_UPLOAD, createDownloadFile } from '@michelin/maestro-file-upload';
import { useTranslation } from 'react-i18next';
import { ShareValues } from '../../../helpers/ShareValues';
import { useEnqueueSnackbar } from '../../../hooks/useEnqueueSnackbar';
var useStyles = makeStyles(function () { return ({
    accordionSummaryContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
}); });
var ATTACHMENT_ERROR_MESSAGE = 'There was an issue getting the attachment, please try again';
var UPLOAD_ATTACHMENTS_PATH = 'central/faqAttachments';
export function ExpandablePanels(_a) {
    var _this = this;
    var faqs = _a.faqs;
    var _b = __read(useState(null), 2), expanded = _b[0], setExpanded = _b[1];
    var classes = useStyles();
    var snackbar = useEnqueueSnackbar();
    var t = useTranslation().t;
    var handleAttachmentDownload = function (faqId) { return __awaiter(_this, void 0, void 0, function () {
        var accessToken, res, data, attachment, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    accessToken = ShareValues.getAuthResultTokenAccess();
                    return [4 /*yield*/, fetch("".concat(API_UPLOAD, "/").concat(UPLOAD_ATTACHMENTS_PATH, "?limit=100&metaKey=custom1&metaValue=").concat(faqId, "&scanForward=false&$skip=0"), {
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken),
                            },
                            method: 'GET',
                        })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = _a.sent();
                    attachment = data.files.find(function (file) { return !file.deleted; });
                    if (attachment) {
                        createDownloadFile({
                            bearer: "Bearer ".concat(accessToken),
                            file: "".concat(API_UPLOAD, "/").concat(attachment.id),
                            name: attachment.filename,
                        });
                    }
                    else {
                        snackbar.enqueueMessages(t(ATTACHMENT_ERROR_MESSAGE), 'error');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    snackbar.enqueueMessages(t(ATTACHMENT_ERROR_MESSAGE), 'error');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null, faqs.map(function (faq) { return (React.createElement(Accordion, { expanded: faq.id === expanded, onClick: function () { return setExpanded(faq.id === expanded ? null : faq.id); }, key: faq.id, id: "faq-".concat(faq.id) },
        React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMore, null), classes: { content: classes.accordionSummaryContent } },
            React.createElement(Typography, { style: faq.id === expanded ? { fontWeight: 'bold' } : {} }, faq.title),
            faq.has_attachment
                && (React.createElement(Tooltip, { title: "".concat(t('Download attachment')) },
                    React.createElement(AttachFile, { fontSize: "small", color: "primary", style: { cursor: 'pointer' }, onClick: function (e) {
                            e.stopPropagation();
                            handleAttachmentDownload(faq.id);
                        }, id: "faq-".concat(faq.id, "-attachment-button"), "data-testid": "faq-attachment-button" })))),
        React.createElement(AccordionDetails, { style: { display: 'block', cursor: 'pointer' }, id: "faq-".concat(faq.id, "-details") },
            React.createElement("div", { dangerouslySetInnerHTML: { __html: faq.html } })))); })));
}
//# sourceMappingURL=ExpandablePanels.js.map